// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"87d2b815","226":"b5fd8f75","419":"7a2a4369","453":"84b72db2","632":"861bc3e1","638":"41a1d4b7","811":"c7287c3d","995":"847108f0"}[chunkId] + ".chunk.js";
};